import * as React from 'react';
import { observable, action, reaction, computed } from 'mobx';
import { observer } from 'mobx-react';
import { padStart as _padStart, debounce as _debounce } from 'lodash';
import { IVendor } from '../../../../common/interfaces/vendor';
import { PortalSearchBarField } from '../layout';
import { SearchForm } from '../forms';
import { app } from '../../App';
import { IWarehouse, IWarehouseApi } from '../../../../common/interfaces/warehouse';

// Styles
const s = require('./WarehousePicker.css');

// Props
interface IWarehousePickerProps {
    selectedWarehouseCode?: string;
    onSelectedWarehouseChange?: (whsCode: string) => void;
}

// Component
@observer
export class WarehousePicker extends React.Component<IWarehousePickerProps, {}> {
    static get defaultProps(): IWarehousePickerProps {
        return {
            selectedWarehouseCode: null,
            onSelectedWarehouseChange: null
        };
    }

    constructor(props: IWarehousePickerProps) {
        super(props);

        this.fetchWarehouses();
    }

    @observable private loading: boolean = false;
    @observable private searchValue: string = '';
    @observable private warehouses: IWarehouse[] = [];

    @computed
    private get searchValueTrimmed(): string {
        return this.searchValue.trim();
    }

    @computed
    private get warehousesList(): IWarehouse[] {
        const search = this.searchValueTrimmed.toLowerCase();
        return search.length > 0
            ? this.warehouses.filter(warehouse => {
                  const vendorCardCode = warehouse.whsCode ? warehouse.whsCode.toLowerCase() : '';
                  const vendorCardName = warehouse.whsName ? warehouse.whsName.toLowerCase() : '';
                  return vendorCardCode.indexOf(search) !== -1 || vendorCardName.indexOf(search) !== -1;
              })
            : this.warehouses;
    }

    render() {
        return (
            <div>
                <SearchForm
                    onSearchValueChange={this.handleWarehouseSearchChange}
                    onResultSelected={this.handleWarehouseSelectionChange}
                    searchValue={this.searchValue}
                    searchLabel="Pick warehouse"
                    loadingResults={this.loading}
                    resultsLoadingLabel="Loading warehouses"
                    results={this.warehousesList.map(vendor => ({
                        key: vendor.whsCode,
                        value: vendor.whsCode,
                        label: vendor.whsCode + ' - ' + vendor.whsName
                    }))}
                    resultSelected={this.props.selectedWarehouseCode}
                    resultsLabel="Warehouses"
                    noResultsLabel="No warehouses available"
                />
            </div>
        );
    }

    @action
    private handleWarehouseSearchChange = (value: string) => {
        this.searchValue = value;
    };

    @action
    private handleWarehouseSelectionChange = (whsCode: string) => {
        if (this.props.onSelectedWarehouseChange) {
            this.props.onSelectedWarehouseChange(whsCode);
        }
    };

    @action
    private fetchWarehouses = async () => {
        try {
            this.loading = true;

            const service = await app.service('warehouse');
            const warehouses = (await service.find({ query: { $limit: 10000 } })) as IWarehouseApi;

            this.warehouses = warehouses.data;
            this.loading = false;

            return true;
        } catch (error) {
            console.error(error);
            return error;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/warehouse/WarehousePicker.tsx